import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { IcCubes, IcBuilding, IcTags, IcUniversity } from "../../Icons";

const ITEMS = [
  {
    label: "Empresas",
    icon: IcBuilding,
    color: "#3b82f6",
    bg: "#eff6ff",
    href: "/ListadoEmpresas",
    desc: "Empresas con las que se opera",
  },
  {
    label: "Categorías",
    icon: IcTags,
    color: "#10b981",
    bg: "#f0fdf4",
    href: "/ListadoCategorias",
    desc: "Efectivo, Transferencia, Huara",
  },
  {
    label: "Cuentas",
    icon: IcUniversity,
    color: "#f59e0b",
    bg: "#fffbeb",
    href: "/ListadoCuentas",
    desc: "Cuentas donde entra y sale el dinero",
  },
];

function BotonesCatalogos() {
  const { user } = useContext(AuthContext);

  return (
    <>
      <Header />
      <div className="card container col-12" style={{ padding: "20px 24px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 24 }}>
          <div style={{
            width: 36, height: 36, borderRadius: 8, background: "#eff6ff",
            display: "flex", alignItems: "center", justifyContent: "center",
            border: "1px solid #bfdbfe",
          }}>
            <IcCubes style={{ color: "#3b82f6", fontSize: "1rem" }} />
          </div>
          <div>
            <h3 style={{ margin: 0, fontSize: "1rem", fontWeight: 700, color: "#0f172a" }}>
              Catálogos
            </h3>
            <p style={{ margin: 0, fontSize: "0.75rem", color: "#64748b" }}>
              Empresas, categorías y cuentas
            </p>
          </div>
        </div>

        {user.menu_catalogos ? (
          <div className="row">
            {ITEMS.map((r, i) => (
              <div key={i} className="col-6 col-md-4 col-xl-3 mb-3">
                <a
                  href={r.href}
                  style={{
                    display: "flex", flexDirection: "column", alignItems: "center", gap: 10,
                    padding: "22px 14px", background: "#fff", borderRadius: 10,
                    boxShadow: "0 1px 3px rgba(0,0,0,0.07)", border: "1px solid #f1f5f9",
                    textDecoration: "none", color: "#334155", textAlign: "center",
                    transition: "box-shadow 0.15s, transform 0.15s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.1)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.07)";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <div style={{
                    width: 52, height: 52, borderRadius: 12, background: r.bg,
                    display: "flex", alignItems: "center", justifyContent: "center",
                  }}>
                    <r.icon style={{ color: r.color, fontSize: "1.35rem" }} />
                  </div>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: "0.82rem", marginBottom: 2 }}>{r.label}</div>
                    <div style={{ fontSize: "0.7rem", color: "#94a3b8", lineHeight: 1.3 }}>{r.desc}</div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        ) : (
          <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso a catálogos.</p>
        )}
      </div>
    </>
  );
}

export default BotonesCatalogos;
